/** @format */

import React from 'react'
import Checkbox from '../Checkbox/Checkbox'
import Loader from '../Loaders/Loader'

const SelectableCommissions = ({
  disabled,
  isBusy,
  selectableCommissionItem,
  setSelectableCommissionItem,
  prefix,
}) => {
  const handleCheckDebitTypeCommissions = (commissions, checkValue) => {
    const com = [...selectableCommissionItem?.commissions].map(comm => {
      if (comm.id === commissions.id) {
        return { ...comm, checked: checkValue }
      }
      return comm
    })

    setSelectableCommissionItem({
      ...selectableCommissionItem,
      commissions: com,
    })
  }

  return (
    <div className="px-4">
      {isBusy ? (
        <Loader />
      ) : (
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {selectableCommissionItem?.commissions.map(commissions => (
            <li
              key={commissions.id}
              style={{ listStyle: 'none' }}
              className=" d-flex align-items-center"
            >
              <Checkbox
                id={`${prefix ? prefix : 'com'}-${commissions.id}`}
                checked={commissions.checked}
                disabled={disabled}
                margined
                onCheck={c => {
                  handleCheckDebitTypeCommissions(commissions, c)
                }}
              />
              <label
                htmlFor={`${prefix ? prefix : 'com'}-${commissions.id}`}
                className={`fw-normal ms-2 cursor-pointer ${
                  commissions.checked ? 'text-primary fw-bold' : ''
                }`}
              >
                {commissions.description}
              </label>
            </li>
          ))}
        </div>
      )}
    </div>
  )
}

export default SelectableCommissions
